var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"alert",class:{'alert-success':_vm.isOnlineDb,'alert-warning':!_vm.isOnlineDb},on:{"click":_vm.switchOnlineState}},[_vm._v(_vm._s(_vm.isOnlineDb))])])
}
var staticRenderFns = []

export { render, staticRenderFns }